var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-1 flex flex-col gap-4"},_vm._l((_vm.$attrs.ui),function(i,index){return _c("Row",_vm._b({key:index,tag:"component"},'component',i,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }